<template>
  <HeaderComponent />
  <NavigationComponent :alwaysShowLogo="true" />
  <GPTsGridComponent />
  <FooterComponent />
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import NavigationComponent from '@/components/NavigationComponent.vue';
import GPTsGridComponent from '@/components/GPTsGridComponent.vue';
import FooterComponent from '@/components/FooterComponent.vue';

export default {
  components: {
    HeaderComponent,
    NavigationComponent,
    GPTsGridComponent,
    FooterComponent
  },
};
</script>

<style scoped>
.font-roboto {
  font-family: 'Roboto', sans-serif;
}

.font-orbitron {
  font-family: 'Orbitron', sans-serif;
}
</style>
